import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
export var AuthLayout = function () { return _jsx(Outlet, {}); };
